export default __webpack_public_path__ + "static/recruitment-image-2-fcc468f0dfb6ed772a47348631e8e881.jpg";